/**
 * Feature - Represents a feature definition with name and description.
 * Used to define features in the model with their definitions, names, and descriptions.
 */
export class Feature {
  /** Feature definition identifier */
  FeatureDefinition: string;

  /** Feature name */
  Name: string;

  /** Feature description */
  Description: string;

  /**
   * Creates a new Feature instance
   * @param data - Object containing feature properties
   */
  constructor(data: {
    FeatureDefinition: string;
    Name: string;
    Description: string;
  }) {
    this.FeatureDefinition = data.FeatureDefinition;
    this.Name = data.Name;
    this.Description = data.Description;
  }

  /**
   * Creates a Feature from a plain object (useful for deserialization)
   * @param obj - Plain object with feature data
   * @returns New Feature instance
   */
  static fromObject(obj: Partial<Feature>): Feature {
    return new Feature({
      FeatureDefinition: obj.FeatureDefinition ?? "",
      Name: obj.Name ?? "",
      Description: obj.Description ?? "",
    });
  }

  /**
   * Converts the Feature to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      FeatureDefinition: this.FeatureDefinition,
      Name: this.Name,
      Description: this.Description,
    };
  }
}


